import {
  Box,
  Button,
  Card,
  CircularProgress,
  Container,
  Grid,
  IconButton,
  Modal,
  Stack,
  Tooltip,
  Typography
} from "@mui/material";
import { useEffect, useState } from "react";
import Page from "src/components/Page";
import DeleteIcon from "@mui/icons-material/Delete";
import { insertPrimeMagazine, magazineDelete, updatePrimeMagazine } from "src/api/commonapi";
import { notification } from "src/utils/messages";
import DataTable from "react-data-table-component";
import { DeleteSharp, EditSharp, PictureAsPdf } from "@mui/icons-material";
import { Routes } from "../constant/api_url";
import { fetchPrimeMagazineList } from "src/utils/common";
import Deletemodal from "./DeleteModal";
import CustomLoader from "src/components/CustomLoader";

export default function MembershipFlow() {
  const [dvisible, setDvisible] = useState({ mval: false, id: 0 });
  const [response, setresponse] = useState(0);
  const [addEditModal, setAddEditModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedMagazineId, setSelectedMagazineId] = useState(null);
  const [magazineData, setMagazineData] = useState({
    files: []
  });
  const [tableData, setTableData] = useState([]);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: isEditMode ? "30%" : "60%",
    maxHeight: "60vh",
    bgcolor: "background.paper",
    boxShadow: 10,
    borderRadius: "10px",
    p: 2,
    overflowY: "auto"
  };

  const toggleAddEditModal = () => setAddEditModal(!addEditModal);

  const resetFormData = () => {
    setMagazineData({
      files: []
    });
    setIsEditMode(false);
  };

  const handleMagazineSubmit = async () => {
    if (magazineData.files && magazineData.files.length > 0) {
      const formData = new FormData();
      let response;

      try {
        if (isEditMode) {
          setLoading(true);
          // Update with a single image
          formData.append("document", magazineData.files[0]);
          formData.append("magazine_id", selectedMagazineId);
          response = await updatePrimeMagazine(formData);
          setLoading(false);
        } else {
          // Insert all selected images
          magazineData.files.forEach((file) => {
            formData.append("document[]", file); // Use consistent key for multiple file
          });
          setLoading(true);
          response = await insertPrimeMagazine(formData);
          setLoading(false);
        }

        const notify = notification({
          type: response.status === 0 ? "error" : "success",
          message: response.message
        });
        notify();

        if (response.status !== 0) {
          resetFormData();
          toggleAddEditModal();
          getMagazine();
        }
      } catch (error) {
        notification({
          type: "error",
          message: "Error uploading files. Please try again."
        })();
        console.error("Upload Error:", error);
      }
    } else {
      notification({
        type: "error",
        message: "Please select file before submitting."
      })();
    }
  };

  const magazinedelete = async (magazine_id) => {
    const resp = await magazineDelete(magazine_id);
    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    });
    notify();

    if (resp.status == 1) {
      setresponse(response + 1);
      setDvisible({ mval: false, id: 0 });
    }
    getMagazine();
  };

  const getMagazine = async () => {
    setLoading(true)
    let res = await fetchPrimeMagazineList();
    setLoading(false)
    setTableData(res);
  };

  useEffect(() => {
    getMagazine();
  }, []);

  const columns = [
    {
      name: "No",
      wrap: true,
      selector: (row, index) => index + 1,
      sortable: true,
      width: "70px"
    },
    {
      name: "Document",
      selector: (row) => {
        const originalName = row?.document
          ? row.document.split("_").slice(1).join("_")
          : row?.document;

        return (
          <a
            href={`${Routes.API_HOSTNAME}images/magazine/${row?.document}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ display: "flex", alignItems: "center", gap: "5px" }}
          >
            <PictureAsPdf style={{ color: "red" }} />
            {originalName}
          </a>
        );
      },
      sortable: false
    },
    {
      name: "Action",
      wrap: true,
      sortable: true,
      width: "170px",
      selector: (row) => (
        <>
          <>
            <Tooltip title="Edit File">
              <IconButton
                onClick={() => {
                  setMagazineData({
                    files: [`${Routes.API_HOSTNAME}images/magazine/${row?.document}`]
                  });
                  setSelectedMagazineId(row.magazine_id); // Store the ID for update
                  setIsEditMode(true);
                  toggleAddEditModal();
                }}
              >
                <EditSharp color="warning" />
              </IconButton>
            </Tooltip>
          </>
          <>
            <a
              onClick={() => {
                setDvisible({ mval: true, id: row.magazine_id });
              }}
            >
              <Tooltip title="Delete">
                <IconButton>
                  <DeleteSharp color="error" />
                </IconButton>
              </Tooltip>
            </a>
          </>
        </>
      )
    }
  ];

  return (
    <>
      <Deletemodal visible={dvisible} setVisible={setDvisible} deletefunc={magazinedelete} />
      <Page title="Magazine | Local Vocal Business Group">
        <Container>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
                <Typography variant="h4" gutterBottom>
                  Magazine
                </Typography>
              </Stack>
            </Grid>
            <Grid item xs={6}>
              <Button
                onClick={() => {
                  toggleAddEditModal();
                  resetFormData();
                }}
                style={{ marginBottom: "15px", float: "right" }}
                variant="contained"
              >
                Add Magazine
              </Button>
            </Grid>
          </Grid>

          <Modal
            open={addEditModal}
            onClose={() => {
              toggleAddEditModal();
              resetFormData();
            }}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <Typography
                id="modal-modal-title"
                variant="h6"
                component="h2"
                style={{ marginBottom: "5px", textAlign: "center" }}
              >
                {isEditMode ? "Edit Magazine" : "Add New Magazine"}
              </Typography>
              <hr />
              <Stack spacing={10} style={{ marginBottom: "15px" }}>
                <Grid container>
                  <Grid item xs={12} sm={12} p={2}>
                    <div className="selectImage" style={{ textAlign: "center" }}>
                      {magazineData?.files?.length > 0 ? (
                        <div
                          style={{
                            display: "flex",
                            gap: "10px",
                            flexWrap: "wrap",
                            justifyContent: "center"
                          }}
                        >
                          {magazineData.files.map((file, index) => {
                            const isFileObj = file instanceof File;
                            const fileUrl = isFileObj ? URL.createObjectURL(file) : file;

                            // Extract original filename
                            let fileName = "";

                            if (isFileObj) {
                              fileName = file.name;
                            } else {
                              const filenameWithTimestamp = file.split("/").pop(); // e.g., "1720450795433_Order.pdf"
                              const parts = filenameWithTimestamp.split("_");
                              parts.shift(); // remove timestamp
                              fileName = parts.join("_");
                            }

                            return (
                              <div
                                key={index}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  padding: "8px 12px",
                                  border: "1px solid #ddd",
                                  borderRadius: "6px",
                                  marginBottom: "10px",
                                  backgroundColor: "#f9f9f9",
                                  gap: "10px"
                                }}
                              >
                                <img
                                  src={process.env.PUBLIC_URL + `/static/pdf.png`}
                                  alt="PDF Icon"
                                  width="32"
                                  height="32"
                                />
                                <a
                                  href={fileUrl}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ textDecoration: "none", color: "#000" }}
                                >
                                  {fileName}
                                </a>

                                {!isEditMode && (
                                  <IconButton
                                    aria-label="delete"
                                    size="small"
                                    style={{
                                      marginLeft: "auto",
                                      backgroundColor: "red",
                                      color: "white"
                                    }}
                                    onClick={() => {
                                      const updatedFiles = magazineData.files.filter(
                                        (_, i) => i !== index
                                      );
                                      setMagazineData({
                                        ...magazineData,
                                        files: updatedFiles
                                      });
                                    }}
                                  >
                                    <DeleteIcon fontSize="small" />
                                  </IconButton>
                                )}
                              </div>
                            );
                          })}
                        </div>
                      ) : (
                        <h5>No Images Selected</h5>
                      )}

                      <Button variant="contained" component="label" style={{ marginTop: "20px" }}>
                        {isEditMode ? "Select File" : "Click to Upload File"}
                        <input
                          id="file"
                          name="file"
                          type="file"
                          hidden
                          multiple={!isEditMode} // Multiple selection only allowed in Add mode
                          accept="application/pdf"
                          onChange={(e) => {
                            const selectedFiles = Array.from(e.target.files);
                            const maxSize = 20 * 1024 * 1024; // 20MB in bytes

                            if (isEditMode) {
                              const selectedFile = selectedFiles[0];

                              if (selectedFile) {
                                if (selectedFile.size > maxSize) {
                                  let notify = notification({
                                    type: "error",
                                    message: `${selectedFile.name} exceeds 20MB limit.`
                                  });
                                  notify();
                                  e.target.value = "";
                                  return;
                                }

                                setMagazineData({
                                  ...magazineData,
                                  files: [selectedFile]
                                });
                              }
                            } else {
                              if (selectedFiles.length === 0) {
                                setMagazineData({
                                  ...magazineData,
                                  files: []
                                });
                                return;
                              }

                              // ✅ File type validation (Only PDF allowed)
                              const allArePDFs = selectedFiles.every(
                                (file) => file.type === "application/pdf"
                              );
                              if (!allArePDFs) {
                                let notify = notification({
                                  type: "error",
                                  message: "Only PDF files are allowed."
                                });
                                notify();
                                return;
                              }

                              const validFiles = selectedFiles.filter((file) => {
                                if (file.size > maxSize) {
                                  let notify = notification({
                                    type: "error",
                                    message: `${file.name} exceeds 2MB limit.`
                                  });
                                  notify();
                                  return false;
                                }
                                return true;
                              });

                              if (validFiles.length === 0) {
                                let notify = notification({
                                  type: "error",
                                  message: "Please select images under 2MB."
                                });
                                notify();
                                e.target.value = "";
                                setMagazineData({
                                  ...magazineData,
                                  files: []
                                });
                                return;
                              }

                              setMagazineData({
                                ...magazineData,
                                files: validFiles
                              });
                            }
                          }}
                          className="form-control"
                        />
                      </Button>
                    </div>
                  </Grid>
                </Grid>
              </Stack>

              {/* Fixed Button Container */}
              <Grid
                container
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "10px",
                  marginTop: "15px"
                }}
              >
                <Button variant="outlined" onClick={() => (toggleAddEditModal(), resetFormData())}>
                  Close
                </Button>
                <Button
                  variant="contained"
                  onClick={handleMagazineSubmit}
                  disabled={loading}
                  startIcon={loading && <CircularProgress size={20} color="inherit" />}
                >
                  Submit
                </Button>
              </Grid>
            </Box>
          </Modal>

          <Card className="p-20" sx={{ mt: 2 }}>
            {tableData && (
              <>
                <DataTable
                  filter
                  pagination
                  highlightOnHover
                  columns={columns}
                  data={tableData != null ? tableData : []}
                   progressPending={loading}
 progressComponent={<CustomLoader />}


                />
              </>
            )}
          </Card>
        </Container>
      </Page>
    </>
  );
}
